import { Button } from "@/components/elements/Button";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { loginSchema } from "@/features/auth/schema/loginSchema";
import { loginApi } from "@/features/auth/services/loginApi";
import { TLoginRequest } from "@/features/auth/types/loginRequest";
import { setErrorForm, showError } from "@/utils/error";
import { getLastAuthRoute } from "@/utils/lastAuthRoute";
import { getQueryFromURL, getSafeRedirectURL } from "@/utils/url";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack } from "@mui/material";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

type TQuery = {
  email: string;
  redirectUrl: string;
};

export const LoginForm = () => {
  const navigate = useNavigate();
  const query = getQueryFromURL<TQuery>();

  const defaultValues = useMemo(() => {
    if (query && query.email) return { email: query.email };
  }, [query]);

  const methods = useForm<TLoginRequest>({
    defaultValues,
    mode: "onChange",
    resolver: yupResolver(loginSchema),
  });
  const { control } = methods;

  const onSubmit = async (data: TLoginRequest) => {
    try {
      await loginApi(data);

      const fallback = getSafeRedirectURL(getLastAuthRoute());
      navigate(getSafeRedirectURL(query?.redirectUrl, fallback));
    } catch (error) {
      showError(error);
      setErrorForm(methods, error);
    }
  };

  return (
    <Form methods={methods} onSubmit={onSubmit} enableBlocker={false} schema={loginSchema} submitOnEnter>
      <Stack gap={3} width={400}>
        <FormField control={control} name="email">
          <Input size="lg" />
        </FormField>
        <FormField control={control} name="password">
          <Input type="password" size="lg" />
        </FormField>
        <Button type="submit" variant="primary" fullWidth>
          ログイン
        </Button>
      </Stack>
    </Form>
  );
};
